<script setup lang="ts">
import { computed } from 'vue';
import type { GenericField } from '@Types';
import type { FieldSchema } from '../../../types';
import { convertToTitleCase } from '@Helpers';

defineOptions({ inheritAttrs: false });

const props = defineProps<{
  disabled?: boolean;
  error?: string;
  field?: FieldSchema;
  options?: GenericField[];
}>();

const model = defineModel<any>();

const sanitizedOptions = computed(() => props.field?.edit?.options || props.options);
const filteredOptions = computed(() =>
  sanitizedOptions.value?.filter((opt: any) => opt !== null && opt !== undefined)
);

function extractValue(option: any) {
  return isSimpleOption(option) ? option : option.value;
}

function isSimpleOption(option: any): option is string {
  return typeof option === 'string';
}

function getOptionLabel(option: any) {
  return isSimpleOption(option) ? option : option.name || option.value;
}

function getOptionKey(option: any) {
  return isSimpleOption(option) ? option : `${getOptionLabel(option)}_${option.value}`;
}
</script>

<template>
  <div class="flex flex-wrap gap-4">
    <div
      v-for="option in filteredOptions"
      class="flex items-center"
      :key="getOptionKey(option)"
    >
      <RadioButton
        :modelValue="isSimpleOption(model) ? model : model?.value"
        :disabled="field?.state?.disabled || disabled"
        :inputId="getOptionKey(option)"
        :invalid="!!error"
        :name="getOptionLabel(option)"
        :value="isSimpleOption(option) ? option : option.value"
        @update:modelValue="
          (val) => {
            const value = extractValue(option);
            model = value;
          }
        "
      />

      <label
        :class="['ml-2 text-sm', { 'af-field-error': !!error }]"
        :for="getOptionKey(option)"
      >
        {{ convertToTitleCase(getOptionLabel(option)) }}
      </label>
    </div>
  </div>
</template>
